/** 社区相关接口调用 */

import '../../@types';
import { PassFactory } from '../../@types/lipass';
import { isInWujie } from './env';
import { getUserGameLanguage } from './i18n';
import { getUserRegion } from './login';

declare let userInfo: PassFactory.UserInfo;

export function isWujieRelease() {
    return isInWujie() && parent.location.host === 'camp.honorofkings.com';
}

export function isWujiePrerelease() {
    return isInWujie() && parent.location.host === 'camp-pre.honorofkings.com';
}

export function isWujieTest() {
    // return parent.location.host === 'camp-test.honorofkings.com';
    return isInWujie() && !isWujieRelease() && !isWujiePrerelease();
}

/** 请求社区API */
export async function requestCampApi(path: string, params?: any, region?: string) {
    // 正式环境：https://api-camp.honorofkings.com
    // 预发环境：https://prerelease-api-camp.honorofkings.com
    // 测试环境：https://testmesh-api-camp.honorofkings.com
    const urlPrefix = isWujieRelease() ? 'https://api-camp.honorofkings.com' : isWujiePrerelease() ? 'https://prerelease-api-camp.honorofkings.com' : 'https://testmesh-api-camp.honorofkings.com';
    const p = fetch(urlPrefix + path, {
        method: 'POST',
        body: params == null ? '' : JSON.stringify(params) ?? '',
        // @ts-ignore
        headers: {
            'Content-Type': 'application/json',
            gameId: '29134',
            gameOpenId: userInfo.openid,
            gameToken: userInfo.token,
            campSource: 'HOK',
            'Camp-Language': getUserGameLanguage(),
            // @ts-ignore
            channel: String(userInfo.channel_info.channelId),
            'Camp-Region': region ?? (await getUserRegion()) ?? '344',
            'trpc-trans-info': isWujieTest() ? '{"x-hok-env": "cmV2aWV3"}' : '',
        },
    });
    return p
        .then(async (rsp) => {
            // 请求成功
            const ret = await rsp.json();
            console.info('[Act][综合站API] 请求成功: ' + path, ret);
            return ret;
        })
        .catch((err) => {
            console.error('[Act][综合站API] 请求失败' + path, err);
        });
}

/** 英雄百科 获取所有英雄信息 */
export async function getAllHeroBrieinfo(region?: string) {
    return requestCampApi('/api/herowiki/getallherobriefinfo', undefined, region);
}
// @ts-ignore
window.getAllHeroBrieinfo = getAllHeroBrieinfo;

/** 批量获取一级评论列表 + 翻译 */
export async function batchGetCommentList(commentIDs: string[]) {
    return requestCampApi('/api/game/comment/batchgetcommentlist', { commentIDs: Array.from(new Set(commentIDs)) });
}
// @ts-ignore
window.batchGetCommentList = batchGetCommentList;

/** 获取英雄点评评论列表 + 翻译 */
export async function getHeroReviewCommentList(params: { heroID: number; listReq?: { page: number; pageSize: number; type: number } }) {
    return requestCampApi('/api/game/review/getheroreviewcommentlist', params);
}
// @ts-ignore
window.getHeroReviewCommentList = getHeroReviewCommentList;
